<template>
  <el-dialog title="打标" :visible.sync="markingShow" width="460px" size="small">
    <el-form class="search-form">
      <el-form-item label="AI推荐打标：" label-width="100px" v-if="aiData.length != 0">
        <div v-for="(item, index) in aiData" :key="index" :class="item.productid == aiId ? 'aiChangeStyle' : 'aiStyle'"
          @click="clickAi(item)">
          {{ item.productname }}
        </div>
      </el-form-item>
      <el-form-item label="打标设置：" label-width="100px">
        <el-cascader filterable clearable v-model="changeProductid" :options="options" :props="productidChildren"
          collapse-tags style="width: 100%;" @change="noClickAi"></el-cascader>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="confire_btn" size="small" @click="changeupdate">确 定</el-button>
      <el-button @click="markingShow = false" size="small" type="cancel_blue">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>

export default {
  name: 'batchMarkingChild',
  props: {
    type: String,
    platform: String,
  },
  data() {
    return {
      ids: '',
      aiId: '',
      options: [],
      changeProductid: [],
      productidChildren: {
        value: "id",
        label: "productClassifyName",
        children: "children"
      },
      markingShow: false,
      aiData: [],
    };
  },
  // mounted() {

  // },
  methods: {
    startChange(skuId, itemid, ids) {
      this.changeProductid = [];
      this.aiId = '';
      if (this.type == 'single') {
        this.ids = itemid;
      } else if (this.type == 'sku') {
        this.ids = ids;
      }
      this.markingShow = true;
      this.getListBybmcid();
      this.getAiProduct(skuId, itemid);
    },
    // ai打标
    getAiProduct(skuId, itemid) {
      let datas = {
        itemid: itemid,
      }
      if (skuId) {
        datas.skuid = skuId
      }
      fetch({
        url: "hcm/iprNewPluginList/getAiProduct",
        method: "post",
        data: datas,
        timeout: 60 * 1000 * 5
      })
        .then(res => {
          console.log(res)
          if (res.status == '10000') {
            this.aiData = res.data;
            this.aiId = '';
            this.markingShow = true;
          } else {
            this.$message({
              message: res.message,
              type: 'warning'
            });
          }
        })
    },
    getListBybmcid() {
      fetch({
        url: "hcm/hcmProduct/getListBybmcid",
        method: "get",
        noFormat: true,
        responseType: "text"
      }).then(res => {
        let result = JSON.parse(res);
        if (result.status == "10000") {
          this.options = result.data;
        }
      });
    },
    noClickAi() {
      this.aiId = ''
    },
    clickAi(data) {
      this.changeProductid = [];
      this.aiId = data.productid;
    },

    // 确定批量打标
    changeupdate() {
      if (this.type == 'sku') {
        this.updateSkuProductid('hcm/iprNewPluginList/updateSkuProductid')
      } else if (this.type == 'single') {
        this.updateSkuProductid('hcm/iprNewPluginList/updateProduct')
      }
    },
    updateSkuProductid(url) {
      let datas = {
        platform: this.platform,
      }
      if (this.type == 'single') {
        datas.itemids = this.ids
        if (this.aiId) {
          datas.autotype = 1
          datas.product_id = this.aiId
        } else {
          datas.autotype = 0
          datas.product_id = this.changeProductid[1].split(',')[0]
        }
      } else {
        datas.ids = this.ids
        if (this.aiId) {
          datas.autotype = 1
          datas.productid = this.aiId
        } else {
          datas.autotype = 0
          datas.productid = this.changeProductid[1].split(',')[0]
        }
      }

      // if (this.aiId) {
      //   datas.autotype = 1
      //   datas.productid = this.aiId
      // } else {
      //   datas.autotype = 0
      //   datas.productid = this.changeProductid[1].split(',')[0]
      // }
      fetch({
        url: url,
        method: "post",
        data: datas,
        timeout: 60 * 1000 * 5
      })
        .then(res => {
          console.log(res)
          if (res.status == '10000') {
            this.$message({
              message: '设置成功',
              type: 'success'
            });
            this.$emit('parent-method')
            this.markingShow = false
            // this.getSkuList(this.skuLiData)

          } else {
            this.$message({
              message: res.message,
              type: 'warning'
            });
          }
        })
    },
  },
};
</script>
<style scoped lang="scss">
.aiStyle {
  margin-bottom: 5px;
  border: 1px solid #dcdfe6;
  border-radius: 4px 0 0 4px;
  padding: 0px 10px;
  cursor: pointer;
}

.aiChangeStyle {
  margin-bottom: 5px;
  border: 1px solid #409eff;
  border-radius: 4px 0 0 4px;
  padding: 0px 10px;
  cursor: pointer;
  background-color: #409EFF;
  color: white;
}

.aiStyle:hover {
  border: 1px solid #409eff;
  background-color: #409EFF;
  color: white;
}
</style>
